import(/* webpackMode: "eager" */ "/var/www/bhq-nextjs/src/app/[locale]/error.js");
